
import React from 'react';
import { useParams } from 'react-router-dom';
import { ScoreboardXML } from '@/components/xml/ScoreboardXML';

export default function ScoreboardXMLPage() {
  const { number } = useParams<{ number: string }>();
  
  if (!number) {
    return (
      <div className="min-h-screen bg-transparent text-white flex items-center justify-center">
        <h1 className="text-2xl">Error: No kit number provided</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <ScoreboardXML kitNumber={number} />
    </div>
  );
}
